<template>
  <div v-if="!params.Hidden">
    <span style="margin-left: 5px">
      <div v-if="params.Title" v-html="params.Title[language]"></div>
    </span>
    <span v-if="params.Required" style="color: red; font-size: 14px">
      * {{ $t("Base.required") }}
    </span>
    <div>
      <fp-toggle-switch
        :state="false"
        :description="params.Description ? params.Description[language] : null"
        :disabled="!params.Enabled != false || disabled"
        type="round"
        :value="tempValue"
        @change="changeValue"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "SwitchComponent",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    params: Object,
    value: [Object, Boolean],
    disabled: Boolean,
    language: String,
  },
  data() {
    return {
      tempValue: this.value ? this.value : this.params.DefaultValue,
    };
  },
  methods: {
    changeValue(input) {
      this.$emit("change", input);
    },
  },
};
</script>
